module.exports = __webpack_public_path__ + "static/media/ECS.730bad2a.png";